import { LS_USER_SUBSCRIPTIONS } from '@config/localstorage.js'
import { useLocalStorage } from '@vueuse/core'
import { isArray } from '@helpers/utils.js'
import { computed } from 'vue'

const followedUsersState = useLocalStorage(LS_USER_SUBSCRIPTIONS, '[]')

export default function () {
  const followedUsers = computed(() => JSON.parse(followedUsersState.value))

  function setMyFollowedUsers(following) {
    followedUsersState.value = JSON.stringify(following)
  }

  function clearMyFollowedUsers() {
    setMyFollowedUsers([])
  }

  function addUserFollow(user) {
    if (
      isArray(followedUsers.value) &&
      !followedUsers.value.find((sub) => sub.id === user.id)
    ) {
      setMyFollowedUsers([...followedUsers.value, user])
    }
  }

  function removeUserFollow(user) {
    const updated = followedUsers.value.filter(
      (subscription) => subscription.id !== user.id
    )
    setMyFollowedUsers(updated)
  }

  function isFollowingUser(userNameId) {
    return computed(() =>
      followedUsers.value?.some((follow) => follow.name_id === userNameId)
    )
  }

  return {
    clearMyFollowedUsers,
    setMyFollowedUsers,
    removeUserFollow,
    isFollowingUser,
    followedUsers,
    addUserFollow,
  }
}
